// to run this script: tap cmd-shift-1 on keyboard; enter `cps_import_assessments`
if (!window.custom_scripts) window.custom_scripts = {}
window.custom_scripts.cps_import_assessments = {
	input_required: true,

	processed_activity_data: [],
	case_payload: null,

	log: '',
	add_to_log: function(s) { this.log += `${s}\n` },

	fn: async function(input, btn_clicked) {
		this.log = ''

		let framework_record = vapp.case_tree_component.framework_record
		let case_json = framework_record.json
		// console.log(framework_record)

		// parse parameters from input
		// Sample input:
/*
// World languages
// sheet: https://docs.google.com/spreadsheets/d/1hbK7vMUWf0KHPSEyIfKfd_HbZFf_CXtK_7lhMs4-XZc/edit?gid=0#gid=0

// process: 1234, 1297
*/
		try {
			let o = {}
			let lines = input.split(/\n/)
			for (let line of lines) {
				line = line.trim()
				// skip empty lines and comments
				if (empty(line)) continue
				if (line.search(/^\/\//) == 0) continue

				if (line.search(/^\s*(.*?)\s*:\s*(.*?)\s*$/) > -1) {
					o[RegExp.$1] = RegExp.$2
				} else {
					this.add_to_log(`***ERROR: couldn’t process input line: ${line}`)
					return this.log
				}
			}
			input = o

		} catch(e) {
			console.error(e)
			this.add_to_log(`***ERROR: couldn’t process input`)
			return this.log
		}
		console.log('input', input)
		
		////////////////////////////////
		// if btn_clicked is 'run', process the input
		let show_save = false
		if (btn_clicked == 'run') {
			this.processed_activity_data = []

			// if input.sheet is empty, use sample data
			let raw_data
			if (empty(input.sheet)) {
				raw_data = this.sample_data
			} else {
				// try to get already-fetched data
				if (empty(vapp.retrieved_raw_data)) vapp.retrieved_raw_data = {}
				raw_data = vapp.retrieved_raw_data[input.sheet]

				if (empty(raw_data)) {
					// fetch the raw_data from the google sheet
					raw_data = await this.fetch_sheet_as_csv(input.sheet)
				} else console.warn('already got data')
				// if we didn't get data, die
				if (empty(raw_data)) {
					this.add_to_log(`***ERROR: couldn’t retrieve data from sheet`)
					return this.log
				}

				// store fetched data so we don't have to re-fetch it again if we're testing
				vapp.retrieved_raw_data[input.sheet] = raw_data
			}

			// if input.process is empty, process all activities
			if (empty(input.process)) input.process = 'all'
			else {
				// this should be the first and the last activity rows to process
				input.process = input.process.split(/\s*,\s*/)
			}

			// split data into rows
			let rows = window.CSV.parse(raw_data)
			// console.warn('raw data', rows)

			// NOTE: this script was based on the script for processing sparkl activities, so we use the term "activity" instead of "assessment" in most places below.
			// process each included activity
			let row_number = 0
			let activities_found = 0
			let unit_last_lesson_with_assessment = {}
			while (row_number < rows.length) {
				// try to process the next activity
				let ecs_result = await this.ecs_process(row_number, rows)

				row_number = ecs_result[0]
				let activity_data = ecs_result[1]

				//////////////////////////
				// if we didn't receive back activity_data, we got an error
				if (empty(activity_data)) {
					this.log += ecs_result[2]	// this will be the log_lines
					this.log = '***ERROR (see below)\n\n' + this.log
					return this.log
				}

				// allow for only processing certain activities...
				++activities_found
				if (input.process !== 'all') {
					// first value should be the first activity to process; second value should be the last activity to process
					// these should both be 1-indexed, so correct accordingly
					if ((activities_found+1) < input.process[0]) continue
					if ((activities_found+1) > input.process[1]) continue
				}

				// if we get to here we're processing this activity, so add its log_lines to the log
				this.log += ecs_result[2]	// this will be the log_lines

				// console.warn('received', row_number, activity_data)

				// keep track of the last lesson that has a lesson assessment for the activity
				if (!empty(activity_data.lesson)) {
					// we will assume for now that the lesson assessments are always in ascending order in the spreadsheet
					unit_last_lesson_with_assessment[`${activity_data.course}.${activity_data.unit}`] = activity_data.lesson
				}

				//////////////////////////
				// based on the activity_code, look for the activity's parent, and see if the activity already exists

				let case_activity_parent = case_json.CFItems.find(x=>x.humanCodingScheme == activity_data.parent_code)

				// if we can't find a parent, die
				if (empty(case_activity_parent)) {
					this.add_to_log('***ERROR: Couldn’t find activity_parent: ' + activity_data.parent_code)
					return this.log
				}
				// console.warn(object_copy(case_activity_parent))

				// now look for item
				let case_activity_item = case_json.CFItems.find(x=>x.humanCodingScheme == activity_data.activity_code)
				let s
				if (!empty(case_activity_item)) {
					s = 'Replace CFItem: ' + activity_data.activity_code
				} else {
					s = 'CREATE CFItem: ' + activity_data.activity_code
				}
				this.add_to_log(`Add to parent ${case_activity_parent.humanCodingScheme}: ${s}\n`)

				///////////////////////////////
				// push this activity's data to processed_activity_data, then go on to the next row
				this.processed_activity_data.push({
					activity_data: activity_data,
					case_activity_parent: case_activity_parent,
					case_activity_item: case_activity_item,
				})
			}

			// for unit and IPA assessments, we want to put them in the first lesson from the unit that *doesn't* have a lesson assessment.
			// Usually this is the last lesson, but some units have "reader" lessons
			// console.log('unit_last_lesson_with_assessment', unit_last_lesson_with_assessment)
			for (let pa of this.processed_activity_data) {
				let activity_data = pa.activity_data
				// if this is a unit-level assessment...
				if (empty(activity_data.lesson)) {
					// compute the lesson to add to
					let last_la_lesson = unit_last_lesson_with_assessment[`${activity_data.course}.${activity_data.unit}`]
					if (empty(last_la_lesson) || last_la_lesson.search(/L(\d+)/) == -1) {
						console.warn(activity_data)
						this.add_to_log('***ERROR: Couldn’t find last lesson-activity lesson: ' + activity_data.activity_code)
						return this.log
					}
					let next_lesson = 'L' + (RegExp.$1 * 1 + 1)
					activity_data.parent_code += `.${next_lesson}`

					let case_activity_parent = case_json.CFItems.find(x=>x.humanCodingScheme == activity_data.parent_code)

					// if we can't find a parent, die
					if (empty(case_activity_parent)) {
						this.add_to_log('***ERROR: Couldn’t find activity_parent for unit-level assessment: ' + activity_data.parent_code)
						return this.log
					} 

					pa.case_activity_parent = case_activity_parent
					this.add_to_log(`Add unit-level assessment to parent ${case_activity_parent.humanCodingScheme}: ${activity_data.activity_code}`)
				}
			}

			// if we get through the loop, there was no error
			this.log = `--------------------\n`
				+ `PRE-PROCESSED ${this.processed_activity_data.length} ACTIVITY(s):\n`
				+ `--------------------\n\n`
				+ `${this.log}\n`
				+ `--------------------\n`
				+ `PROCESSING CFITEMS: \n\n`

			show_save = true

			////////////////////////////////
			// formulate CF data to send
			this.case_payload = {
				update_document_date: 'yes',
				check_out_and_in: 'yes',
				lsdoc_identifier: framework_record.lsdoc_identifier,
				CFItems: [],			// we will add only the updated properties of CFItems
				CFAssociations: [],		// but we will add the entire CFAssociations
			}

			// for each processed activity...
			for (let pa of this.processed_activity_data) {
				let msg = `Activity ${pa.activity_data.activity_code}:`

				// update or create the CFItem for the activity
				let cfi = new CFItem(pa.case_activity_item)

				// fill in identifier, uri, and date for new items
				if (empty(cfi.identifier)) cfi.complete_data(case_json.CFDocument)
				cfi.fullStatement = pa.activity_data.human_name
				cfi.humanCodingScheme = pa.activity_data.activity_code
				cfi.language = 'en'
				cfi.CFItemType = 'Assessment'

				// fill in educationLevel
				let course = pa.activity_data.activity_code.replace(/^(SP|FR)\.(.*?)\..*/, '$2')
				if (pa.activity_data.course.includes('HS')) cfi.educationLevel = ['09', '10', '11', '12']
				else if (course == 'GPK') cfi.educationLevel = ['PK']
				else if (course == 'GK') cfi.educationLevel = ['KG']
				else cfi.educationLevel = ['0' + course[1]]	// 01,02,03,...08

				// extensions
				if (empty(cfi.extensions)) cfi.extensions = {}
				cfi.extensions.ocxType = 'Activity'
				cfi.extensions.learningResourceType = 'assessment'
				cfi.extensions.educationalUse = 'assessment'
				cfi.extensions.provider = 'Chicago Public Schools'

				// set extensions.assessmentSourcedId to the stable_link_id (this is what Checkpoint uses to identify CPS assessments)
				if (!empty(pa.activity_data.stable_link_id)) {
					cfi.extensions.assessmentSourcedId = pa.activity_data.stable_link_id
				}

				// set extensions.assessmentInfoURL if we have one
				if (!empty(pa.activity_data.assessment_info_url)) {
					cfi.extensions.assessmentInfoURL = pa.activity_data.assessment_info_url
				} else {
					// if we don't have an assessmentInfoURL for the assessment itself, see if we have one for the assessment's course
					let course_item = U.trace_up_to_ancestor(framework_record, pa.case_activity_parent, 'Course')
					console.warn('course_item: ', course_item?.fullStatement)
					if (course_item?.extensions?.assessmentInfoURL) {
						cfi.extensions.assessmentInfoURL = course_item.extensions.assessmentInfoURL
					}
				}

				// set extensions.summary if we have a description
				if (!empty(pa.activity_data.description)) {
					cfi.extensions.summary = pa.activity_data.description
				}

				// see if the cfitem is new or has changed (have to run cfi.to_json() first)
				cfi = cfi.to_json()
				let changed = (empty(pa.case_activity_item))
				if (!changed) for (let key in cfi) {
					if (JSON.stringify(cfi[key]) != JSON.stringify(pa.case_activity_item[key])) {
						changed = true
						break
					}
				}

				// if changed, add the CFItem to the payload for save
				if (changed) {
					this.case_payload.CFItems.push(cfi)
					if (empty(pa.case_activity_item)) {
						msg += ` /   CFItem CREATED`
					} else {
						msg += ` /   CFItem UPDATED`
					}
				} else {
					msg += ` / CFItem unchanged`
				}

				// and if the item didn't exist before, place it under its parent
				if (empty(pa.case_activity_item)) {
					// get highest sequence number
					let pnode = framework_record.cfo.cfitems[pa.case_activity_parent.identifier].tree_nodes[0]
					let seq = U.get_next_sequenceNumber(pnode, framework_record)

					// generate the isChildOf assoc
					let assoc = U.create_association(pa.case_activity_parent, cfi, seq, case_json.CFDocument, 'isChildOf')

					// add to payload
					this.case_payload.CFAssociations.push(assoc.to_json())

					msg += ` / CFAssociation CREATED`

				// if we're told to update parents...
				} else if (input.update_parents == 'yes') {
					// get the existing CFAssociation for the item
					let assoc = case_json.CFAssociations.find(x=>
						x.associationType == 'isChildOf'
						&& x.originNodeURI.identifier == cfi.identifier
					)
					if (empty(assoc)) {
						this.add_to_log('***ERROR: Couldn’t find isChildOf association for existing assessment: ' + cfi.humanCodingScheme)
						return this.log
					}

					// if parent has changed, we need to update the assoc
					if (assoc.destinationNodeURI.identifier != pa.case_activity_parent.identifier) {
						// make a copy of the assoc
						assoc = new CFAssociation(assoc)
						assoc.destinationNodeURI = {
							title: U.generate_cfassociation_node_uri_title(pa.case_activity_parent),
							identifier: pa.case_activity_parent.identifier,
							uri: pa.case_activity_parent.uri
						}

						// add to payload
						this.case_payload.CFAssociations.push(assoc.to_json())
						msg += ` / CFAssociation UPDATED`

					// else assoc is unchanged
					} else {
						msg += ` / CFAssociation unchanged`
					}

				} else {
					msg += ` / CFAssociation not checked`
				}

				this.add_to_log(msg)
			}

			// if there's anything to save, say so and keep the save btn showing
			if (this.case_payload.CFItems.length > 0 || this.case_payload.CFAssociations.length > 0) {
				this.log = `--------------------\nREADY TO SAVE ${this.case_payload.CFItems.length} CFItem(s) and ${this.case_payload.CFAssociations.length} CFAssociation(s):\nclick a btn above to execute save, or update spreadsheet and re-run\n--------------------\n\n${this.log}`
				show_save = true
				console.warn('payload', this.case_payload)

			} else {
				// else reset case_payload and hide the save btn
				this.log = `--------------------\nNO CFItems OR CFAssociations NEED TO BE UPDATED:\nupdate spreadsheet and click btn above to re-run\n--------------------\n\n${this.log}`
				this.case_payload = null
				show_save = false
			}

		////////////////////////////////
		// if we get to here, btn_clicked is 'save' and we have the case_payload, so save
		} else {
			vapp.$store.dispatch('save_framework_data', this.case_payload).then(()=>{
				vapp.$alert('Reload to see updated framework data').then(x=>{
					vapp.reload_window()
				})
			})
		}

		return [this.log, show_save]
	},

	async fetch_sheet_as_csv(sheet_url) {
		// h/t Gemini
		let base_url = sheet_url.split('/edit')[0]
		let url_params = new URLSearchParams(new URL(sheet_url).hash.replace('#', '?'))
		let gid = url_params.get('gid') || '0'
		
		let export_url = `${base_url}/export?format=csv&gid=${gid}`
		
		try {
			U.loading_start()
			let response = await fetch(export_url)
			U.loading_stop()
			if (!response.ok) {
				console.error(`Failed to fetch sheet (1): ${response.statusText}`)
				return null
			}
			return await response.text()
		} catch(e) {
			U.loading_stop()
			vapp.$alert('Failed to fetch sheet (see console): ' + e)
			console.warn(e)
			return null
		}
	},

	async ecs_process(row_number, rows) {
		let verbose = false
		let log_lines = ''

		let inform = (msg, fn = 'log') => {
			// if (!verbose && fn == 'log') return
			msg = `Line ${row_number+1}: ${msg}`
			if (fn == 'error') {
				msg = `***ERROR: ${msg} ***`
				vapp.$inform(msg)
			} else if (fn == 'warn') {
				msg = `** ${msg} **`
			}

			// we add the lines to the log *after* we return, in case we're skipping this activity
			log_lines += `${msg}\n`
		}

		let activity_data = null

		while (true) {
			if (verbose) console.log('row_number', row_number)
			// when we've processed all rows, return
			if (row_number >= rows.length) {
				return [row_number, activity_data, log_lines]
			}

			row = rows[row_number]

			// trim all cells and skip empty lines
			let row_empty = true
			for (let i = 0; i < row.length; ++i) {
				row[i] = row[i].trim()
				if (!empty(row[i])) row_empty = false
			}
			if (row_empty) {
				if (verbose) inform('--')
				++row_number
				continue
			}

			// expand row into vars
			let [assessment_name, lti_url, stable_link_id, ss_content_area, ss_grade, ss_unit, ss_path] = row
			// let [activity_code, raw_activity_name, exercise_title, interaction_type, url, exercise_teacher_notes, exercise_student_prompt, exercise_comments, playlist_description, playlist_teacher_prep, playlist_student_instructions] = row

			// skip lines with no stable_link_id
			if (empty(stable_link_id)) {
				console.log('skip line with no stable_link_id')
				++row_number
				continue
			}

			// if assessment_name is 'AssessmentName', assume it's headers
			if (assessment_name.toLowerCase() == 'assessmentname') {
				inform('HEADERS')
				++row_number
				continue
			}

			// if first cell is 'comment', it's a comment
			if (assessment_name.toLowerCase() == 'comment') {
				inform('COMMENT: ' + assessment_name)
				++row_number
				continue
			}

			// if we're here, the row should represent an assessment
			// try to parse the assessment_name to figure out what it is
			let subject, course, unit, lesson, name_code, human_name
			let parent_code		// we want this to be, e.g., SP.GK.U1.L1
			let activity_code		// we want this to be, e.g., SP.GK.U1.L1.LA
			if (/Skyline_WL/i.test(assessment_name)) {
				/*
				Skyline_WLF_PreK_U1_IPA_Presentational SY26
				Skyline_WLF_PreK_U1_L1_LA SY26
				Skyline_WLF_PreK_U1_UA SY26
				Skyline_WLF_GK_U4_IPA_Presentational SY26
				Skyline_WLS_G4_U1_UA SY26
				Skyline_WLS_HS3_U8_L3_LA SY26
				-- with path:
				Skyline_WLS_G6_A_U1_UA SY26
				*/
				let matches = assessment_name.match(/Skyline_WL(\w)_([^_]+?)(_[AB])?_(.+?)_(\S+)/i)
				if (!matches) {
					inform(`***ERROR: couldn’t parse assessment_name “${assessment_name}”`)
					return [row_number, null, log_lines]	
				}

				subject = (matches[1] == 'F') ? 'FR' : 'SP'

				course = matches[2]
				if (course.toLowerCase() == 'prek') course = 'GPK'
				else if (course.toLowerCase() == 'hs1') course = 'HSI'
				else if (course.toLowerCase() == 'hs2') course = 'HSII'
				else if (course.toLowerCase() == 'hs3') course = 'HSIII'
				else if (course.toLowerCase() == 'hs4') course = 'HSIV'
				else if (course[0] != 'G') {
					inform(`***ERROR: couldn’t parse COURSE for assessment_name “${assessment_name}”`)
					return [row_number, null, log_lines]	
				}				
				
				unit = matches[4]
				if (!empty(matches[3])) unit += matches[3][1]	// add 'Path' (A or B) to unit if we have one

				parent_code = `${subject}.${course}.${unit}`

				// get name_code and human_name from matches[5]
				name_code = matches[5]
				// if name_code starts with "L\d", it's a lesson assessment
				if (name_code.search(/^(L\d+)_(.*)/) == 0) {
					lesson = RegExp.$1
					name_code = RegExp.$2
					parent_code += `.${lesson}`
					human_name = `Lesson ${unit.substr(1)}.${lesson.substr(1)} Assessment`

				} else {
					human_name = `Unit ${unit.substr(1)} `
					if (name_code == 'UA') human_name += 'Assessment'
					else {
						human_name += name_code.replace(/_/, ' ')		// 'IPA_Presentational' -> 'IPA Presentational'
						if (name_code.toLowerCase() == 'ipa_interpersonal') name_code = 'IPA_IPE'
						else if (name_code.toLowerCase() == 'ipa_interpretive') name_code = 'IPA_IPR'
						else if (name_code.toLowerCase() == 'ipa_presentational') name_code = 'IPA_PRE'
						else {
							inform(`***ERROR: couldn’t parse NAME_CODE for assessment_name “${assessment_name}”`)
							console.warn(matches)
							return [row_number, null, log_lines]	
						}
					}
				}

				// activity_code is parent_code + name_code
				activity_code = `${parent_code}.${name_code}`
			}

			inform(`√ ${activity_code} ${human_name} (${assessment_name})...`)

			// Here's what we return
			activity_data = {
				// these will definitely be used
				parent_code,
				activity_code,
				human_name,
				stable_link_id,

				// these might be useful for reference
				assessment_name,
				subject,
				course,
				unit,
				lesson,
				name_code,
			}
			++row_number
			return [row_number, activity_data, log_lines]
		}
	},

	// Normalizes any Google Slides URL format into an optimized Iframe Embed URL.
	// Supports standard share links, edit states, and "Publish to Web" links.
	ecs_convert_google_slide_url(url) {
		// Capture 1: The absolute base URL up to the action keyword (handles optional /e/)
		// Capture 2: The entire trailing parameter/hash payload
		let pattern = /^(https:\/\/docs\.google\.com\/presentation\/d\/(?:e\/)?[^\/\?#]+)\/(?:present|edit|pub)(.*)$/i;
		
		let match = url.match(pattern);
		if (!match) {
			// console.error('couldn’t convert google url: ' + url)
			return url
		}
		
		let [_, base_canvas, raw_arguments] = match;
		let normalized_arguments = '';

		if (raw_arguments) {
			// 1. Ensure the parameters initiate with a standard '?' instead of a '#' anchor
			// 2. Convert any internal '#' anchors into valid '&' query separators
			normalized_arguments = raw_arguments
			.replace(/^[?#]/, '?')
			.replace(/#/g, '&');
		}

		return `${base_canvas}/embed${normalized_arguments}`;
	},

	ecs_format_text_content(s) {
		if (empty(s)) return ''
		return s.trim()
		// return s.trim().replace(/\n/g, '<br>')
	},

	ecs_construct_activity_archive(ad) {
		// when generating archives "for real", we use a service (get_json_for_activity_archive), so that we know the format of exported archives
		// will match the format we need for importing archives.
		// Here, though, at present, we'll just create the archive here.
		// This should work fine for the present (5/2026) use case, where we're creating activities for CPS using Vista content.

		// start with the base activity data
		let o = {
			activity: {
				title: ad.title,
				editors: ',sparklcreationscript@commongoodlt.com,',
				exercises: [],
				stars_available: 0,
				teacher_notes: ad.teacher_notes,
				activity_instructions: ad.activity_instructions,

				case_resource_guid: ad.case_resource_guid,

				allow_retry: "yes",
				student_access_policy: "signed_in",
				amd: ad.amd,
				teacher_grading_required: false,
			},
			exercises: []
		}

		// now for each exercise...
		let exercise_number = 1
		for (let exr of ad.exercises) {
			// add to o.activity.exercises
			o.activity.exercises.push({
				exercise_id: exr.exercise_id,
				disabled: exr.disabled,
				number: exercise_number,
			})

			// the disabled flag only goes into activity.exercises, not the exercise DB record
			delete exr.disabled

			// add stars to o.activity.stars_available
			o.activity.stars_available += exr.stars_available

			// add to o.exercises
			// the archive format requires a list of query_guids for each exercise record
			exr.query_guids = []
			for (let uuid in exr.queries) {
				exr.query_guids.push(uuid)
				// TODO?: currently we're just passing the "raw" query data through; we *might* need to use the Sparkl query class...
				// exr.queries[uuid] = new Video_Query(exr.queries[uuid])
			}

			// TODO?: do we need to deal with original_activity_id? I think the service takes care of it

			// TODO?: currently we're just passing the "raw" data through; we *might* need to use the Sparkl Exercise_Record class...
			// let exr = new Exercise_Record(ex)
			o.exercises.push(exr)

			++exercise_number
		}

		return o
	},

	// modified from Sparkl ActivityArchives.vue
	async ecs_save_sparkl_activity(fileJSON, existing_sparkl_activity_id) {
		let sparkl_origin = 'https://sparkl-ed.com'

		// for debugging
		// return `${sparkl_origin}/999`

		// fileJSON should mimic the content of a Sparkl Archive file
		// send the fileJSON to the Satchel server, which will send it on to the Sparkl server to create the activity
		// the sparkl_url should be returned
		let payload = {
			clear_existing_exercises: 'yes',	// this clears out the original exercises
			json: fileJSON, 
			teacher_email: 'sparklcreationscript@commongoodlt.com', 

			sparkl_origin: sparkl_origin,
		}

		if (!empty(existing_sparkl_activity_id)) {
			payload.activity_id_to_replace = existing_sparkl_activity_id
		}

		U.loading_start()
		let ajax_result = await U.ajax_promise('create_sparkl_activity_from_archive', payload)
		U.loading_stop()
		if (ajax_result.status != 'ok') {
			// handle error: return null; caller will show an error and cancel what it is doing (ajax_promise will console.log the result)
			return null
		}

		// return activity url, which includes the sparkl_activity_id
		return `${sparkl_origin}/${ajax_result.sparkl_activity_id}`
	},

	ecs_get_sparkl_activity_id(url) {
		if (empty(url)) return null
		return url.replace(/^.*\/(\d\d+)$/, '$1')
	},

	sample_data: `
Activity Code,Activity Name,Exercise Title,Interaction Type,URL,Teacher Notes,Student Prompt,Comments,Playlist Description,Playlist Teacher Prep Notes,Playlist Student Instructions
SP.GK.U2.L1.A1,Elementary Spanish K 2.1.1 La ropa y los colores,Elementary Spanish K 2.1 La ropa y los colores,Google Slide,https://docs.google.com/presentation/d/1cI5iYxE5Uh_khaK6FkMvFZ4fi1NImaDyEFzw-aeW7yw/present?slide=id.g6074d3f457_0_0,"<p>Use this playlist for Day 1 of Unit 2 Lesson 1 - La ropa y los colores<br>
Proficiency level: Novice Low</p>Proficiency level: Novice Low","Welcome to Unit 2 Lesson 1 Day 1. We will introduce the places in Peru that Becky,
Kate, and their family will visit.
Bienvenidos al Día 1 de la Lección 1 de la Unidad 2. Presentaremos los sitios de Perú
que visitarán Becky, Kate y su familia.",This is an introduction to: Elementary Spanish Grade K - Unit 2 - Lesson 1 - Day 1,"In previous weeks the family traveled to Honduras, where they made new friends and visited several exciting places. The family is now visiting Peru, another Spanish-speaking country. They watch a parade and talk about clothes and colors.

Proficiency Level: Novice Low","Students will learn the names of colors and clothes. As a warm-up, place several blue, green, red, and yellow counters on your desk. Have volunteers identify the colors in English. Then invite students, one by one, to come to the front and choose a counter. Ask them to keep the counters on their desks for the playlist's activities. 

As you go through the objects in the playlist, you can click on the graduation cap to see the answer key for each activity.

Teacher Facilitation Guide can be found here.","Play each item in the playlist and follow the instructions to learn the names of some clothes and colors. 

Reproduce los elementos de la lista y sigue las instrucciones para aprender el nombre de algunas prendas de vestir y los colores."
SP.GK.U2.L1.A1,Elementary Spanish K 2.1.1 La ropa y los colores,Elementary Spanish K 2 Essential Question,Google Slide,https://docs.google.com/presentation/d/1oeTyVJjgurMKkqu36vdFI9m0pTZt-fqyj_3p5-_FXL8/present#slide=id.g5ee18f2284_0_0,"Explain to students that in the following days and weeks they will talk about the
people and places that are part of a community as they follow Kate, Becky, and their
parents on their visit to Peru. Tell them to pay attention to the places and people they
meet and try to connect them with the people and places they see every day in their
own community in Chicago.
At the end of this journey, they will be able to answer this question: How does being
part of a community help us? (¿Cómo nos ayuda ser parte de una comunidad?) Write
the question on the board, both in English and Spanish, and refer to it any time you
consider to be a good opportunity for students to answer it.","In the following weeks, you will follow Becky, Kate, and their parents on their journey to Peru. Listen to the question your teacher asks and think about it when you see and hear what the characters do.

En las próximas semanas, acompañarás a Becky, Kate y sus padres en su viaje por Perú. Escucha la pregunta que hará tu maestro y piensa en ella a medida que escuches y veas lo que hacen los personajes.",Activity to present the Essential Question of this unit: How does being part of a community help us? (¿Cómo nos ayuda ser parte de una comunidad?),"In previous weeks the family traveled to Honduras, where they made new friends and visited several exciting places. The family is now visiting Peru, another Spanish-speaking country. They watch a parade and talk about clothes and colors.

Proficiency Level: Novice Low","Students will learn the names of colors and clothes. As a warm-up, place several blue, green, red, and yellow counters on your desk. Have volunteers identify the colors in English. Then invite students, one by one, to come to the front and choose a counter. Ask them to keep the counters on their desks for the playlist's activities. 

As you go through the objects in the playlist, you can click on the graduation cap to see the answer key for each activity.

Teacher Facilitation Guide can be found here.","Play each item in the playlist and follow the instructions to learn the names of some clothes and colors. 

Reproduce los elementos de la lista y sigue las instrucciones para aprender el nombre de algunas prendas de vestir y los colores."
SP.GK.U2.L1.A1,Elementary Spanish K 2.1.1 La ropa y los colores,La ropa y los colores - Descubre Perú,LTI Link (VHL),771567_771567_cpsdeasbu2l1001,"Pueblo de Yanque:Point to the picture and explain that it shows the small town, or pueblo, of Yanque, in Peru. The town is having a celebration and people are wearing their typical attire. Becky, Kate, and their parents will visit the town of Yanque.
Ciudad de Arequipa: Point to the picture and tell students that it shows the main
square, or plaza, of the city of Arequipa. Explain that cities are very large towns. Cities
usually include buildings, houses, shopping centers, and parks.
Patio de la casa: Point to the picture and tell students that it shows a house's patio.
Explain that in Peru, houses often have patios, and that people enjoy being outdoors.
Plaza de la comunidad: Point to the picture and tell students that it shows
a plaza in Julio’s community. Explain that friends who live in the community like to
meet, talk, and spend time together in the plaza. A plaza may have fountains, benches,
and green areas.
Have students identify some of these places in their city, Chicago.","Look at these pictures of different places in Peru. Say what you see.
Mira las fotos de diferentes lugares de Perú. Di lo que ves.","This opener offers a preview of the unit's content and introduces the four places that the characters will visit in Peru: pueblo de Yanque, ciudad de Arequipa, the patio of a house, and a community square.","In previous weeks the family traveled to Honduras, where they made new friends and visited several exciting places. The family is now visiting Peru, another Spanish-speaking country. They watch a parade and talk about clothes and colors.

Proficiency Level: Novice Low","Students will learn the names of colors and clothes. As a warm-up, place several blue, green, red, and yellow counters on your desk. Have volunteers identify the colors in English. Then invite students, one by one, to come to the front and choose a counter. Ask them to keep the counters on their desks for the playlist's activities. 

As you go through the objects in the playlist, you can click on the graduation cap to see the answer key for each activity.

Teacher Facilitation Guide can be found here.","Play each item in the playlist and follow the instructions to learn the names of some clothes and colors. 

Reproduce los elementos de la lista y sigue las instrucciones para aprender el nombre de algunas prendas de vestir y los colores."
SP.GK.U2.L1.A1,Elementary Spanish K 2.1.1 La ropa y los colores,Elementary Spanish Photo Card: amarillo / verde / azul / rojo,Google Slide,https://docs.google.com/presentation/d/1CFGzNn_KWO_KuYu6v4K00JSG9XDgyKSt-drsz8hep0I/present#slide=id.g6074d3f457_0_0,"Frontload Vocabulary: Point to the colored squares one at a time and say the color
words in Spanish: amarillo (yellow), azul (blue), rojo (red), and verde (green). Have
students repeat after you. Distribute counters. Then point to the squares again. Say
the color in Spanish and ask students who have a counter of the same color to hold it
up as they say its color in Spanish.","Look at the colored squares. Say the colors in Spanish.
Mira los cuadrados de colores. Di los nombres de los colores en español.",Activity to name colors in Spanish.,"In previous weeks the family traveled to Honduras, where they made new friends and visited several exciting places. The family is now visiting Peru, another Spanish-speaking country. They watch a parade and talk about clothes and colors.

Proficiency Level: Novice Low","Students will learn the names of colors and clothes. As a warm-up, place several blue, green, red, and yellow counters on your desk. Have volunteers identify the colors in English. Then invite students, one by one, to come to the front and choose a counter. Ask them to keep the counters on their desks for the playlist's activities. 

As you go through the objects in the playlist, you can click on the graduation cap to see the answer key for each activity.

Teacher Facilitation Guide can be found here.","Play each item in the playlist and follow the instructions to learn the names of some clothes and colors. 

Reproduce los elementos de la lista y sigue las instrucciones para aprender el nombre de algunas prendas de vestir y los colores."
SP.GK.U2.L1.A1,Elementary Spanish K 2.1.1 La ropa y los colores,La ropa y los colores - La ropa y los colores,LTI Link (VHL),771568_771568_cpsdeasbu2l1002_,"Build Background: Direct students’ attention to the picture. Explain that the
photo shows a small town, or pueblo, in Peru. Tell students that it is common for
towns to have celebrations. During these celebrations, groups of people wear their
town’s traditional attire and dance traditional dances. Ask students if they have ever
seen a group of dancers in their city, Chicago, during a parade or similar event. Invite
volunteers to share descriptions of the dancers, such as the clothes they were wearing
and the color of their clothes.
Frontload Vocabulary: Read the dialogue to students as you point to each speech
bubble. Then have students repeat the dialogue together, after you. You may wish to
repeat this process two or three times.","Listen to the dialogue. Then repeat what each character says.
Escucha el diálogo. Luego, repite lo que dice cada personaje.","Becky, Kate, and their parents watch a parade in Yanque. They talk about their
favorite colors.","In previous weeks the family traveled to Honduras, where they made new friends and visited several exciting places. The family is now visiting Peru, another Spanish-speaking country. They watch a parade and talk about clothes and colors.

Proficiency Level: Novice Low","Students will learn the names of colors and clothes. As a warm-up, place several blue, green, red, and yellow counters on your desk. Have volunteers identify the colors in English. Then invite students, one by one, to come to the front and choose a counter. Ask them to keep the counters on their desks for the playlist's activities. 

As you go through the objects in the playlist, you can click on the graduation cap to see the answer key for each activity.

Teacher Facilitation Guide can be found here.","Play each item in the playlist and follow the instructions to learn the names of some clothes and colors. 

Reproduce los elementos de la lista y sigue las instrucciones para aprender el nombre de algunas prendas de vestir y los colores."
SP.GK.U2.L1.A1,Elementary Spanish K 2.1.1 La ropa y los colores,La ropa y los colores - Video : La ropa y los colores,LTI Link (VHL),776572_776572_cpsdeasbu2l1014,"Have students play the video and listen to what the family has to say about the parade
in Yanque.
Pause the video after each sentence and have students repeat. Ask students to point to
an object of the color mentioned in each sentence to ensure comprehension.
You may wish to turn captions on so that students can follow the dialogue.","Play the video. Listen to what each character says. Repeat each sentence.
Reproduce el video. Escucha lo que dice cada personaje. Repite las oraciones.","Video that shows Becky, Kate, and their parents watching a parade in Yanque.","In previous weeks the family traveled to Honduras, where they made new friends and visited several exciting places. The family is now visiting Peru, another Spanish-speaking country. They watch a parade and talk about clothes and colors.

Proficiency Level: Novice Low","Students will learn the names of colors and clothes. As a warm-up, place several blue, green, red, and yellow counters on your desk. Have volunteers identify the colors in English. Then invite students, one by one, to come to the front and choose a counter. Ask them to keep the counters on their desks for the playlist's activities. 

As you go through the objects in the playlist, you can click on the graduation cap to see the answer key for each activity.

Teacher Facilitation Guide can be found here.","Play each item in the playlist and follow the instructions to learn the names of some clothes and colors. 

Reproduce los elementos de la lista y sigue las instrucciones para aprender el nombre de algunas prendas de vestir y los colores."
SP.GK.U2.L1.A1,Elementary Spanish K 2.1.1 La ropa y los colores,La ropa y los colores - ¿Qué color te gusta?,LTI Link (VHL),771569_771569_cpsdeasbu2l1003_,"Language in Context: Have students look at the pictures. Explain that the
characters are wearing a poncho and that they will learn more about ponchos at the
end of the week.
Read the question and have students repeat it after you. Point to each character and
read what they say. Have students repeat each statement after you. Ask students if
they think Becky and Kate’s dad would like the color yellow. Role-play the dad saying
Me gusta el amarillo. (I like the color yellow.)
Invite volunteers to answer the question ¿Qué color te gusta? (What color do you
like?) Have them use the model Me gusta el... (I like the color ...).","Listen to what Kate, Becky, and their mom say. Repeat each sentence. Then, say
which color you like.
Escucha lo que dicen Kate, Becky y su mamá. Repite cada oración. Luego, di qué color te gusta.",Listening and speaking activity to express the color you like.,"In previous weeks the family traveled to Honduras, where they made new friends and visited several exciting places. The family is now visiting Peru, another Spanish-speaking country. They watch a parade and talk about clothes and colors.

Proficiency Level: Novice Low","Students will learn the names of colors and clothes. As a warm-up, place several blue, green, red, and yellow counters on your desk. Have volunteers identify the colors in English. Then invite students, one by one, to come to the front and choose a counter. Ask them to keep the counters on their desks for the playlist's activities. 

As you go through the objects in the playlist, you can click on the graduation cap to see the answer key for each activity.

Teacher Facilitation Guide can be found here.","Play each item in the playlist and follow the instructions to learn the names of some clothes and colors. 

Reproduce los elementos de la lista y sigue las instrucciones para aprender el nombre de algunas prendas de vestir y los colores."
SP.GK.U2.L1.A1,Elementary Spanish K 2.1.1 La ropa y los colores,La ropa y los colores - Video: ¿Qué color te gusta?,LTI Link (VHL),776571_776571_cpsdeasbu2l1013,"Have students play the video and listen to Kate, Becky, and their mother talking about
their favorite colors.
Pause the video after each statement and have students repeat.
You may wish to turn captions on so that students can follow the audio.
Invite volunteers to answer the question ¿Qué color te gusta? (What color do you
like?) Have them answer using the model Me gusta el... (I like the color ...).
Then, say: Raise your hands if you are wearing something azul. Stand up if you are
wearing something rojo. Clap your hands if you are wearing something amarillo.","Play the video and listen to what Kate, Becky, and their mom say. Repeat each
sentence. Say what color do you like.
Reproduce el video para escuchar lo que dicen Kate, Becky y su mamá. Repite cada oración. Di qué color te gusta.","Video that shows Kate, Becky, and their mother saying which colors they like.","In previous weeks the family traveled to Honduras, where they made new friends and visited several exciting places. The family is now visiting Peru, another Spanish-speaking country. They watch a parade and talk about clothes and colors.

Proficiency Level: Novice Low","Students will learn the names of colors and clothes. As a warm-up, place several blue, green, red, and yellow counters on your desk. Have volunteers identify the colors in English. Then invite students, one by one, to come to the front and choose a counter. Ask them to keep the counters on their desks for the playlist's activities. 

As you go through the objects in the playlist, you can click on the graduation cap to see the answer key for each activity.

Teacher Facilitation Guide can be found here.","Play each item in the playlist and follow the instructions to learn the names of some clothes and colors. 

Reproduce los elementos de la lista y sigue las instrucciones para aprender el nombre de algunas prendas de vestir y los colores."
SP.GK.U2.L1.A1,Elementary Spanish K 2.1.1 La ropa y los colores,Elementary Spanish K 2.1.1 Predecir,Google Slide,https://docs.google.com/presentation/d/1xsDKNinSLx1WB_HcU21qYtNNxM0nQIbIx4KZX8B0bSw/present#slide=id.g5ee18f2284_0_0,"Predict: Explain to students that tomorrow they will listen to a story. Have them look
at the illustrations. Ask them what they think the story might be about. Explain that by
telling what they think might happen in a story based on what they see in an
illustration they are making a prediction.
Draw a word web on the board and write los colores de la ropa in the main circle. You
might want to gesture to your clothing to indicate the meaning of ropa. Point to the
clothing in the pictures and ask students in Spanish what color different items are.
This might be an opportunity to expose them to the names of the clothing items ahead
of the next lesson through comprehensible input. Encourage students to answer using
the colors that they've just learned, as well as the characters’ names. Write the colors
they say in Spanish in different circles in a web around the main circle and do not
erase your word web until you confirm predictions after reading.","Look at the pictures. Say what you think the story might be about.
Mira las ilustraciones. Di de qué crees que trata la historia.",Preview of Unit 2 Lesson 1 Day 2 story,"In previous weeks the family traveled to Honduras, where they made new friends and visited several exciting places. The family is now visiting Peru, another Spanish-speaking country. They watch a parade and talk about clothes and colors.

Proficiency Level: Novice Low","Students will learn the names of colors and clothes. As a warm-up, place several blue, green, red, and yellow counters on your desk. Have volunteers identify the colors in English. Then invite students, one by one, to come to the front and choose a counter. Ask them to keep the counters on their desks for the playlist's activities. 

As you go through the objects in the playlist, you can click on the graduation cap to see the answer key for each activity.

Teacher Facilitation Guide can be found here.","Play each item in the playlist and follow the instructions to learn the names of some clothes and colors. 

Reproduce los elementos de la lista y sigue las instrucciones para aprender el nombre de algunas prendas de vestir y los colores."
`


}

